const PREFIX = 'sigchat-load'

export function markLoadPhase(name: string): void {
  if (typeof performance === 'undefined' || typeof performance.mark !== 'function') return
  performance.mark(`${PREFIX}:${name}`)
}

export function measureLoadPhase(name: string, startMark: string, endMark: string): void {
  if (typeof performance === 'undefined' || typeof performance.measure !== 'function') return
  try {
    performance.measure(`${PREFIX}:${name}`, `${PREFIX}:${startMark}`, `${PREFIX}:${endMark}`)
  } catch {
    return
  }
}
